'use client';
import React, { useState } from 'react';
import { ShoppingCart } from 'lucide-react';
import { useCartStore } from '@/store/cartStore';
import Toast from '@/components/ui/Toast';

interface AddToCartButtonProps {
  course: {
    id: number;
    name: string;
    image: string;
    price: number;
  };
  className?: string;
}

const AddToCartButton: React.FC<AddToCartButtonProps> = ({ course, className = '' }) => {
  const { addToCart, isInCart } = useCartStore();
  const [toast, setToast] = useState<{
    message: string;
    type: 'success' | 'error' | 'info';
  } | null>(null);

  const handleAddToCart = () => {
    if (isInCart(course.id)) {
      setToast({
        message: 'Khóa học đã có trong giỏ hàng!',
        type: 'info',
      });
      return;
    }

    addToCart(course);
    setToast({
      message: `"${course.name}" đã được thêm vào giỏ hàng!`,
      type: 'success',
    });
  };

  const isAlreadyInCart = isInCart(course.id);

  return (
    <>
      {toast && <Toast data-component-id="src/components/common/AddToCartButton.tsx:44:16" data-component-path="src/components/common/AddToCartButton.tsx" data-component-line="44" data-component-end-line="44" data-component-file="AddToCartButton.tsx" data-component-name="Toast" data-component-content="%7B%22elementName%22%3A%22Toast%22%7D" message={toast.message} type={toast.type} onClose={() => setToast(null)} />}

      <button data-component-id="src/components/common/AddToCartButton.tsx:46:6" data-component-path="src/components/common/AddToCartButton.tsx" data-component-line="46" data-component-end-line="69" data-component-file="AddToCartButton.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
        className={`w-full bg-gradient-to-r from-[#4A306D] to-[#3a2557] hover:from-[#3a2557] hover:to-[#2a1a40] text-lg font-bold h-14 group relative overflow-hidden rounded-xl shadow-lg ${
          isAlreadyInCart
            ? 'cursor-not-allowed from-gray-300 to-gray-300 hover:from-gray-300 hover:to-gray-300'
            : 'cursor-pointer'
        }`}
        tabIndex={0}
        style={{ transform: 'none' }}
        onClick={handleAddToCart}
        disabled={isAlreadyInCart}
      >
        <span data-component-id="src/components/common/AddToCartButton.tsx:57:8" data-component-path="src/components/common/AddToCartButton.tsx" data-component-line="57" data-component-end-line="59" data-component-file="AddToCartButton.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22absolute%20left-4%20top-1%2F2%20transform%20-translate-y-1%2F2%20opacity-0%20group-hover%3Aopacity-100%20transition-opacity%20duration-300%22%7D" className="absolute left-4 top-1/2 transform -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <ShoppingCart data-component-id="src/components/common/AddToCartButton.tsx:58:10" data-component-path="src/components/common/AddToCartButton.tsx" data-component-line="58" data-component-end-line="58" data-component-file="AddToCartButton.tsx" data-component-name="ShoppingCart" data-component-content="%7B%22elementName%22%3A%22ShoppingCart%22%7D" className={`w-5 h-5 ${isAlreadyInCart ? 'text-gray-500' : 'text-white'}`} />
        </span>
        <span data-component-id="src/components/common/AddToCartButton.tsx:60:8" data-component-path="src/components/common/AddToCartButton.tsx" data-component-line="60" data-component-end-line="68" data-component-file="AddToCartButton.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22textContent%22%3A%22TH%C3%8AM%20V%C3%80O%20GI%E1%BB%8E%20H%C3%80NG%22%7D"
          className={`${
            isAlreadyInCart
              ? 'text-gray-500'
              : 'text-white group-hover:translate-x-6 inline-block transition-transform duration-300'
          }`}
        >
          THÊM VÀO GIỎ HÀNG
        </span>
      </button>
    </>
  );
};

export default AddToCartButton;
